import type { OrganizationProducts } from "@api/private/getOrganization";

export const AVAILABLE_LICENSE_SKUS = ["sspSlot", "rrpSlot", "ilsSlot"] as const;

export type LicenseSku = (typeof AVAILABLE_LICENSE_SKUS)[number];

/**
 * Maps organization products with "paid" status to their corresponding license SKUs.
 * - SKUs containing "ssp" -> sspSlot
 * - SKUs containing "rrp" -> rrpSlot
 * - SKUs containing "focus" or "ils" -> ilsSlot
 */
export function getLicenseSkusFromProducts(
  organizationProducts: OrganizationProducts,
): LicenseSku[] {
  const skus = new Set<LicenseSku>();

  for (const [sku, productStatus] of Object.entries(organizationProducts)) {
    if (productStatus.status !== "paid") {
      continue;
    }

    const skuLower = sku.toLowerCase();

    if (skuLower.includes("ssp")) {
      skus.add("sspSlot");
    }
    if (skuLower.includes("rrp")) {
      skus.add("rrpSlot");
    }
    if (skuLower.includes("focus") || skuLower.includes("ils")) {
      skus.add("ilsSlot");
    }
  }

  return Array.from(skus);
}
